import React from 'react';
import { Col, Typography } from 'antd';

interface Props {
  title: string;
  number: any;
}

const TotalNumber = ({ title, number }: Props) => {
  return (
    <Col span={6}>
      <div
        style={{
          backgroundColor: 'white',
          padding: '1rem'
        }}
      >
        <Typography.Title style={{ fontSize: '0.8rem' }}>
          {title}
        </Typography.Title>
        <Typography.Text type="secondary" style={{ fontSize: '2rem' }}>
          {number}
        </Typography.Text>
      </div>
    </Col>
  );
};

export default TotalNumber;
